export const cardStyle = {
  margin: "2rem auto",
  maxWidth: "48.125rem",
}